module.exports = __webpack_public_path__ + "img/login-header-banner.af3856f7.png";